export default error => null
